import { GroupTemplatePacksConfirmationModal } from "components/assignmentModals/groupTemplatePacksConfirmationModal/GroupTemplatePacksConfirmationModal";
import { type AppDispatch } from "features/Application/globaltypes/redux";
import { useObserver } from "hooks/useObserver";
import { type IObservable } from "interfaces/IObservable";
import { type FC, useEffect, useMemo } from "react";
import { Observable } from "utils";
import { editPackAccounts } from "../../state/thunks/TemplatePacksThunk";
import { bindAction } from "interfaces";
import { connect, type ConnectedProps } from "react-redux";
import {
  type PackMap,
  type PackAccountsContextItem,
} from "components/assignmentModals/groupTemplatePacksConfirmationModal/types";
import { type PackView } from "../../types/models";
import { LicenseTypes } from "../../../../../enums";
import { reset as resetAvailableDomains } from "../../../../Accounts/state/slices/accountDomainsSlice";

type Props = PropsFromRedux & {
  onTriggerModalObserver: IObservable<(templateId: number, pack: PackView) => void>;
};

export const EditPackAccountsModal: FC<Props> = (props) => {
  const { onTriggerModalObserver, editPackAccounts, resetAvailableDomainsAction } = props;
  const onTriggerPacksConfirmationObserver = useMemo(() => new Observable(), []);

  const [subscribeOnModalTrigger] = useObserver(onTriggerModalObserver);

  const initPackMap = (pack: PackView): PackMap => {
    const map = new Map();
    const item: PackAccountsContextItem = {
      id: pack.id,
      title: pack.title,
      thumbnailImageUrl: pack.thumbnailImageUrl,
      isTrial: false,
      isTrialAllowed: false,
      licenseTypeId: LicenseTypes.CustomDate,
      noExpiration: pack.noExpiration,
      isChanged: pack.noExpiration ?? false,
    };
    map.set(pack.id, item);
    return map;
  };

  useEffect(() => {
    const onTriggerModal = async (templateId: number, pack: PackView) => {
      const packMap = initPackMap(pack);
      onTriggerPacksConfirmationObserver.notify(() => {
        const packItem = packMap.get(pack.id);
        if (packItem?.noExpiration || packItem?.expirationDate) {
          editPackAccounts(templateId, pack.id, packItem?.expirationDate);
        }
      }, packMap);
    };

    return subscribeOnModalTrigger(onTriggerModal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscribeOnModalTrigger]);

  const infoText = "Changing the expiration date will affect all customers in the template.";

  return (
    <GroupTemplatePacksConfirmationModal
      isEdit
      packAccountItemsText={infoText}
      onTriggerModalObserver={onTriggerPacksConfirmationObserver}
      onClose={resetAvailableDomainsAction}
    />
  );
};

/* istanbul ignore next */
const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    editPackAccounts: bindAction(editPackAccounts, dispatch),
    resetAvailableDomainsAction: bindAction(resetAvailableDomains, dispatch),
  };
};

/* istanbul ignore next */
const connector = connect(null, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

const ConnectedComponent = connector(EditPackAccountsModal);
export default ConnectedComponent;
